const FORMULA_VARIABLE_PATTERN = /VARIABLE\s*\(\s*(["'])((?:(?!\1)[\s\S])*)\1\s*\)/g

export function getFormulaVariableKeys(expression: string | null | undefined): string[] {
  if(!expression) {
    return []
  }
  const keys = new Set<string>()
  for(const match of expression.matchAll(FORMULA_VARIABLE_PATTERN)) {
    keys.add(match[2])
  }
  return Array.from(keys)
}

// Fallback for text that is not valid formula syntax, e.g. `https://example.com/VARIABLE("id")`:
// every VARIABLE("key") is swapped for its formatted value and the text around it stays verbatim
export function resolveFormulaVariableTemplate(
  expression: string,
  variables: Record<string, unknown>,
  formatValue: (value: unknown) => string,
): string {
  return expression.replace(FORMULA_VARIABLE_PATTERN, (_match, _quote, key: string) => {
    const value = Object.prototype.hasOwnProperty.call(variables, key) ? variables[key] : null
    return formatValue(value)
  })
}
